<template>
    <div>
        <div class="card">
            <div class="center pt-3 text-center">
                <h2>{{ $t('Suas Avaliações') }}</h2>
                <p>{{ $t('Avaliação referente as OS atendidas nos últimos 30 dias.') }}</p>
                <h2>{{ $t('Nota') }}: {{ notaMecanico }}</h2>
            </div>
            <div class="center text-center d-flex" style="justify-content: center;">
                <ul class="avaliacao p-0">
                    <li class="star-icon " data-avaliacao="1"></li>
                    <li class="star-icon " data-avaliacao="2"></li>
                    <li class="star-icon " data-avaliacao="3"></li>
                    <li class="star-icon" data-avaliacao="4"></li>
                    <li class="star-icon" data-avaliacao="5"></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data () {
    return  {
      nota: '',
    }
  },

  computed: {
    1 (){
      const nota = this.$store.getters['os/notaMecanico']

      return (+nota).toFixed(2)
    }
  },

  created() {
    const filial = this.$store.getters['filial/filial']
    this.$store.dispatch(`os/getNotaMecanico`, { tecnicoId: filial.tecnicoId }).then(response => {
      const numNota = parseFloat(response.data[0].nota)
      this.nota = numNota
      const stars = document.querySelectorAll('.star-icon')
      for(let i = 0; i < numNota; i++){
        stars[i].classList.add('checkado')
      }
    })
  }
}
</script>
<style>
.avaliacao{
  display: flex;
 }
.star-icon{
  list-style-type: none;
  cursor: pointer;
  color: #f1a004;
  font-size: 61px;/* alterar o tamanho das estrelas */
}
.star-icon::before{
  content: "\2606";
}
.star-icon.ativo ~ .star-icon::before{
  content: "\2606";
}
/* .avaliacao:hover .star-icon::before{
  content: "\2605";
}
.star-icon:hover ~ .star-icon::before{
  content: "\2606";
} */
.checkado::before{
  content: "\2605"!important;
}
</style>